import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import Profile from "./components";

const Users = ({ match, location }) => {
  const pathArr = location.pathname.split("/");
  const id = pathArr[pathArr.length - 1];

  return (
    <div className="app-wrapper ">
      <Switch>
        <Route
          path={`${match.url}/user/:id/:section`}
          component={() => <Profile />}
        />
        <Route exact path={`${match.url}/user/:id`}>
          <Redirect to={`${match.url}/user/${id}/Summary`} />
        </Route>
      </Switch>
    </div>
  );
};

export default Users;
